const RiyalIcon = ({ className, fill }) => {
  return (
    <svg
      width="44"
      height="48"
      viewBox="0 0 44 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_33_23071)">
        <path
          d="M27.0958 42.5228C26.3285 44.2221 25.8213 46.0663 25.627 48.0002L41.8651 44.5526C42.6324 42.8536 43.1392 41.0091 43.3339 39.0752L27.0958 42.5228Z"
          fill={fill || "#C42E27"}
        />
        <path
          d="M41.8632 34.2238C42.6305 32.5248 43.1377 30.6803 43.332 28.7464L30.683 31.4333V26.268L41.8628 23.8951C42.6301 22.1962 43.1373 20.3516 43.3316 18.4177L30.6827 21.1024V2.52648C28.7445 3.6134 27.0231 5.06021 25.6239 6.76681V22.1767L20.5651 23.2506V0C18.6269 1.08654 16.9056 2.53374 15.5064 4.24034V24.3242L4.1874 26.7265C3.42007 28.4254 2.91247 30.27 2.71777 32.2039L15.5064 29.4894V35.9942L1.80089 38.9031C1.03356 40.602 0.526349 42.4466 0.332031 44.3805L14.6779 41.3356C15.8457 41.093 16.8494 40.4034 17.502 39.4544L20.1329 35.5586V35.5579C20.406 35.1548 20.5651 34.6688 20.5651 34.1454V28.4155L25.6239 27.3416V37.6721L41.8628 34.223L41.8632 34.2238Z"
          fill={fill || "#C42E27"}
        />
      </g>
      <defs>
        <clipPath id="clip0_33_23071">
          <rect width="43" height="48" fill="white" transform="translate(0.333984)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default RiyalIcon;
